import * as React from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { Circle } from "lucide-react";

import { cn } from "@/lib/utils";

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return <RadioGroupPrimitive.Root className={cn("grid gap-2", className)} {...props} ref={ref} />;
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, disabled, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={`${cn("aspect-square h-5 w-5 rounded-full border-2 border-solid border-slate-400 text-primaryBrand", className)}, ${disabled ? "cursor-not-allowed opacity-50" : ""}`}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        className={`flex items-center justify-center rounded-full border-white bg-white ${disabled ? "cursor-not-allowed disabled:opacity-50" : ""}`}
      >
        <Circle color="white" className={`h-4 w-4 fill-primaryBrand text-current ${disabled ? "opacity-50" : ""}`} />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
});

RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
